export default {"src":"https://static.finncdn.no/_c/travel/pp-web/_next/static/media/f9.b2aa5682.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};